import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShowAll = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "ShowAll",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17556",
		"data-name": "Group 17556",
		transform: "translate(2 2.333)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13038",
				"data-name": "Path 13038",
				d: "M11,6H7a4,4,0,0,0-2.473,7.14",
				transform: "translate(-3 -4.333)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13039",
				"data-name": "Path 13039",
				d: "M9,14.43h4a4,4,0,0,0,2.473-7.14",
				transform: "translate(-5 -4.763)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13040",
				"data-name": "Path 13040",
				d: "M10.667,15.5,9,17.167l1.667,1.667",
				transform: "translate(-5 -7.5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13041",
				"data-name": "Path 13041",
				d: "M12.5,6.833l1.667-1.667L12.5,3.5",
				transform: "translate(-6.167 -3.5)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13042",
		"data-name": "Path 13042",
		d: "M0,0H16V16H0Z",
		fill: "none"
	})]
});
export default SvgShowAll;
